export const text = '#241843';
export const hover = '#000000';
export const gray = '#707070';

